// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GatewayError {
    static getAttributeTypeMap() {
        return GatewayError.attributeTypeMap;
    }
}
GatewayError.discriminator = undefined;
GatewayError.additionalProperties = false;
GatewayError.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=gatewayError.js.map